"use strict";

angular.module("app.elements.visual-cta", [])
  .directive("viVisualCta", function () {
    return {
      templateUrl: "app/js/modules/elements/visual-cta/visual-cta.html"
    };
  });
